<template>
  <v-container fluid class="price-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Price Information</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                    <v-row justify="center">
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">Create New Price</p>
                        <v-select
                          class="mb-4"
                          :items="pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                            })"
                          v-model="price.pricelistid"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Price List"
                          persistent-hint
                          single-line hint="Please choose the price list">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="items.map(x => {
                            return {text: x.itemname, value: x._id};
                            })"
                          v-model="price.itemid"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Item"
                          persistent-hint
                          single-line hint="Please choose the item">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="price.pricename"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Price Name"
                          persistent-hint
                          single-line hint="Enter the price name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="price.minqty"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Min Qty"
                          persistent-hint
                          single-line hint="Enter the minimum quantity">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="price.maxqty"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Max Qty"
                          persistent-hint
                          single-line hint="Enter the maximum quantity">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="price.listprice"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="List Price"
                          persistent-hint
                          single-line hint="Enter the list price">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6" sm="5">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/price/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createPrice()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      price: {
        pricestatus: 'Active'
      },
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Price', ['createPriceRequest', 'getPricesRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    checkError(){
      //if(this.price.pricecode.length>0) {this.step=2; return true;}
      if(!this.price.pricelistid){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.price.itemid){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.price.pricename){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.price.minqty){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.price.maxqty){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.price.listprice){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createPrice() {
      if(this.checkError() == false) return;
      this.createPriceRequest(this.price)
      this.getPricesRequest()
      router.push('/price/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.price.priceimage = file;
      this.price.imagename = file.name;
      this.createImage(file);
    }
  },
  created(){
    if(this.items.length==0) this.getItemsRequest();
  },
  computed: {
    ...mapState('Price', ['isReceiving']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Item', ['items']),
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
